export default {"src":"/_next/static/media/close.8c2dae8d.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};